const MOBILE_WIDTH = 640;
const TABLET_POTRAIT_WIDTH = 1024;

export { MOBILE_WIDTH, TABLET_POTRAIT_WIDTH };
